import React from 'react';

const TicketContext = React.createContext('ticket');

export const TicketContextProvider = TicketContext.Provider;

export default TicketContext;
